const notSuitableSports = ["61", "62", "66", "70", "73", "75"];
export const SuitableSportFilter = (x) => notSuitableSports.indexOf(x.id) === -1;
//# sourceMappingURL=SuitableSportFilter.js.map